var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.611 7.0328C12.6507 6.9925 12.6807 6.94627 12.7011 6.89698C12.722 6.84675 12.7335 6.79167 12.7335 6.73393C12.7335 6.67616 12.722 6.62109 12.7011 6.57086C12.6807 6.52156 12.6507 6.47534 12.611 6.43504L12.6084 6.43241L8.30076 2.12477C8.1344 1.95841 7.86468 1.95841 7.69833 2.12477C7.67916 2.14393 7.6622 2.16447 7.64747 2.18606L3.391 6.43209L3.38916 6.43395C3.3128 6.51093 3.26563 6.61692 3.26563 6.73391C3.26562 6.79161 3.27709 6.84661 3.29787 6.89679C3.31831 6.94626 3.34846 6.99266 3.38834 7.03307L3.39164 7.03638C3.46863 7.11273 3.57461 7.1599 3.69161 7.1599L12.3075 7.15992C12.4155 7.15992 12.5235 7.11909 12.6063 7.03745C12.6079 7.03592 12.6095 7.03437 12.611 7.0328Z",
    fill: "#002466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29795 9.10276C3.31834 9.05348 3.34838 9.00726 3.38807 8.96696L3.39273 8.96229C3.47561 8.88065 3.58361 8.83984 3.69161 8.83984H12.3075C12.4245 8.83984 12.5305 8.88701 12.6075 8.96338L12.6107 8.96669C12.6506 9.0071 12.6808 9.0535 12.7012 9.10297C12.722 9.15313 12.7335 9.20815 12.7335 9.26583C12.7335 9.38284 12.6863 9.48883 12.6099 9.56581L12.6081 9.56765L8.35164 13.8137C8.33688 13.8353 8.31993 13.8558 8.30076 13.875C8.1344 14.0413 7.86468 14.0413 7.69833 13.875L3.39069 9.56734L3.38807 9.56472C3.34838 9.52442 3.31834 9.47818 3.29795 9.4289C3.27712 9.37867 3.26562 9.32359 3.26562 9.26583C3.26562 9.20807 3.27712 9.153 3.29795 9.10276Z",
    fill: "#002466"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort_down.4e919eefa4ecf73a990f5b621b27b6d8.svg";
export { ForwardRef as ReactComponent };